import React from 'react';
import { shapes } from '@cimpress/react-components';
export const Loading = ({ message }) => {
    const { Spinner } = shapes;
    return (React.createElement("div", { style: { display: 'flex', paddingBottom: '20px' } },
        React.createElement("div", { style: { flexGrow: 1, paddingRight: '20px' } },
            React.createElement(Spinner, { size: 'medium' })),
        React.createElement("div", { style: { flexGrow: 1000, lineHeight: '38px' } }, message)));
};
//# sourceMappingURL=Loading.js.map